/**
 * Phase G+ Phase 5b·v2 (19.06.2026) — Export-Seite vorübergehend leer.
 * --------------------------------------------------------------------
 * Auf User-Anweisung wurden alle bisherigen Export-Optionen entfernt.
 * Die neue Export-Architektur wird in Phase 7-8 implementiert (Monatliche
 * Lohnliste + Zulagen-Export für Lohnverrechner).
 */
import { FileDown, Sparkles } from "lucide-react";

export default function ExportPage() {
  return (
    <div className="space-y-4" data-testid="export-page">
      <div>
        <h1 className="font-display text-2xl font-bold text-zinc-50">Export</h1>
        <p className="text-xs text-zinc-500 mt-0.5">
          Datei-Exports für Lohnverrechnung, Behörden und Reporting.
        </p>
      </div>

      <div
        className="rounded-lg border border-zinc-800 bg-zinc-950 p-10 text-center"
        data-testid="export-placeholder"
      >
        <div className="mx-auto w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center">
          <FileDown className="w-6 h-6 text-zinc-500" />
        </div>
        <h2 className="mt-4 font-display text-lg font-semibold text-zinc-100">
          Neue Export-Module in Arbeit
        </h2>
        <p className="mt-2 text-sm text-zinc-400 max-w-md mx-auto">
          Die Export-Architektur wird zusammen mit der neuen Payroll-Engine
          (Phase 6) und der Monatlichen Lohnliste (Phase 7) neu aufgebaut.
          Sobald die genauen Excel-Vorlagen feststehen, kommen sie wieder hier rein.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 text-xs text-amber-300 bg-amber-500/10 border border-amber-500/40 px-3 py-1.5 rounded-md">
          <Sparkles className="w-3.5 h-3.5" />
          Geplant: Monatliche Lohnliste · Zulagen-Lohnverrechner · Behörden-Exporte
        </div>
      </div>
    </div>
  );
}
